<template>
    <v-dialog class="rounded-0" v-model="isActive" width="500" persistent :titulo="titulo"
        transition="dialog-top-transition">
        <v-card>
            <v-card-text class="d-flex flex-row justify-center ma-0">
                <v-icon color="orange darken-2" size="120" class="mt-3">mdi-alert-circle-outline</v-icon>
            </v-card-text>
            <!--  <v-progress-linear v-if="loading" indeterminate height="5" color="orange"></v-progress-linear> -->
            <v-card-text class="d-flex flex-column align-center font-weight-bold text-h6 primary--text">
                {{ titulo }}
            </v-card-text>
            <v-card-text class="d-flex font-weight-regular text-body-1 black--text text-center">
                <div v-html="formatText(text)"></div>
            </v-card-text>
            <!--             <v-card-text>
                <v-alert dense colored-border type="info" color="primary" border="left" class="rounded-0" elevation="6">
                    <div class=" text-body-1">
                        Para más información comuníquese con su Delegación Distrital:
                    </div>
                    <div class="d-flex flex justify-center font-weight-bold primary--text text-body-1">
                        <a :href="'mailto:' + user.emaildistrito">{{ user.emaildistrito }}</a>
                    </div>
                </v-alert>
            </v-card-text> -->
            <v-card-text class="d-flex flex-column align-center">
                <v-btn @click="continuar(true)" width="200px" elevation="0" color="primary" class="pa-5 mb-1">
                    Continuar
                </v-btn>
                <v-btn outlined @click="continuar(false)" width="200px" elevation="0" color="secondary" class="pa-5">
                    cerrar
                </v-btn>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
export default {
    props: {
        titulo: {
            type: String,
            default: 'Atención'
        },
        text: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            isActive: false,
            callback: null,

            //text: "El plazo de presentación para la opción de nivel es dentro de los meses de octubre y noviembre. Si deseas realizar la opción de forma extemporánea, la misma quedará sujeta a consideración del Directorio."
        }
    },
    mounted() {
    },
    methods: {
        ...mapActions('auth', ['cerrarSesion', 'refreshToken']),

        formatText(text) {
            const boldTexts = [
                'quedará sujeta a consideración del Directorio',
                'octubre y noviembre',
                'extemporánea',
            ]
            // Use a regular expression to replace each occurrence of the bold texts with their bolded versions
            boldTexts.forEach(boldText => {
                const regex = new RegExp(boldText, 'g');
                text = text.replace(regex, `<b>${boldText}</b>`);
            });
            return text
        },
        abrirDialog() {
            this.isActive = true;
            return new Promise(resolve => {
                this.callback = resolve;
            })
        },
        continuar(result) {
            if (this.callback) {
                this.callback(result);
                this.callback = null; // Reset the callback to avoid memory leaks
            }
            this.isActive = false
        },
        /*
        goToView() {
            this.$router.push('/mediosDeContacto').catch(() => { })
               }
        */
    },
    computed: {
        ...mapGetters('auth', ['user'])
    },
}

</script>